import * as turf from '@turf/turf';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faDownLeftAndUpRightToCenter, faFileExport, faFloppyDisk, faList, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
//STYLES
import { PainelPropsGrid } from './styled';
//COMPONENTS
import Carregando from '../../../../../../../../../../../../../../../../Components/CustomUi/loading';
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { Render } from '../../../../../../../../../../../../../../../../Components/CustomUi/render';
import { AbaMapa, CorrecaoSobreposicao, PosicaoPopOver, PreparacaoEdicao, PreviaReducaoTrilhas } from './abaMapa';
import { AbaPontos } from './abaPontos';
import { AbasDoGrid } from '../abas';
import { AbaOrdenacao } from './abaOrdenacao';
import { GridMalha, GridPolygon } from '../gerarMalha';
interface PropsConfig {
    disable: boolean
    setDisable: React.Dispatch<React.SetStateAction<boolean>>
    aoCarregarArquivo: (rawData: string, base64Data: string) => void
    validoFile: boolean
    setValidoFile: React.Dispatch<React.SetStateAction<boolean>>
    rotation: number
    setRotation: React.Dispatch<React.SetStateAction<number>>
    rotacaoInput: string
    setRotacaoInput: React.Dispatch<React.SetStateAction<string>>
    movendo: boolean
    setMovendo: React.Dispatch<React.SetStateAction<boolean>>
    novoPonto: boolean
    setNovoPonto: React.Dispatch<React.SetStateAction<boolean>>
    moverPonto: boolean
    setMoverPonto: React.Dispatch<React.SetStateAction<boolean>>
    removerPonto: boolean
    setRemoverPonto: React.Dispatch<React.SetStateAction<boolean>>
    selecionarPonto: boolean
    setSelecionarPonto: React.Dispatch<React.SetStateAction<boolean>>
    gridLevel: string
    setGridLevel: React.Dispatch<React.SetStateAction<string>>
    position: { x: 0; y: 0 }
    setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>
    tab_container_atual: string
    setTab_container_atual: React.Dispatch<React.SetStateAction<string>>
    arquivoSelecionado: string
    setArquivoSelecionado: React.Dispatch<React.SetStateAction<string>>
    setGrid: React.Dispatch<React.SetStateAction<GridMalha[]>>
    setGridOriginal: React.Dispatch<React.SetStateAction<GridMalha[]>>
    setGridOriginalRotacao: React.Dispatch<React.SetStateAction<GridMalha[]>>
    setTamanhoGridOriginal: React.Dispatch<React.SetStateAction<number>>
    setMalhaPolygon: React.Dispatch<React.SetStateAction<GridPolygon[]>>
    setMalhaPolygonOriginal: React.Dispatch<React.SetStateAction<GridPolygon[]>>
    setClicou: React.Dispatch<React.SetStateAction<boolean>>
    setQuadrante: React.Dispatch<React.SetStateAction<number>>
    kmlComCruzamento: boolean
    editandoKml: boolean
    areaHectares: number
    polygon: turf.Feature
    abaAtual: number
    abasNome: any[]
    pontosSelecionados: any[]
    grid: GridMalha[]
    area: any[]
    areaTamanho: number
    quadrante: number
    nomeTalhao: string
    avancar: Function
    voltar: Function
    resetarGrid: Function
    salvarMalha: () => void
    baixarMalha: (tipo: string) => void
    salvarContorno: () => void
    openCorrigirKinks: boolean
    setOpenCorrigirKinks: React.Dispatch<React.SetStateAction<boolean>>
    correcaoSobreposicoes: CorrecaoSobreposicao
    temAlgoParaCorrigir: boolean
    aplicarCorrecaoSobreposicoes: () => void
    openReducaoTrilhas: boolean
    setOpenReducaoTrilhas: React.Dispatch<React.SetStateAction<boolean>>
    distanciaTrilhas: number
    setDistanciaTrilhas: React.Dispatch<React.SetStateAction<number>>
    previaReducaoTrilhas: PreviaReducaoTrilhas
    aplicarReducaoTrilhas: () => void
    openReducaoRetas: boolean
    setOpenReducaoRetas: React.Dispatch<React.SetStateAction<boolean>>
    toleranciaRetas: number
    setToleranciaRetas: React.Dispatch<React.SetStateAction<number>>
    previaReducaoRetas: PreviaReducaoTrilhas
    aplicarReducaoRetas: () => void
    alternarEdicaoKml: () => void
    openPrepararEdicao: boolean
    setOpenPrepararEdicao: React.Dispatch<React.SetStateAction<boolean>>
    preparacaoEdicao: PreparacaoEdicao | null
    limiteVerticesEdicao: number
    totalVerticesContorno: number
    aplicarPreparacaoEdicao: () => void
    editarSemSimplificar: () => void
}
/** Distância entre o painel e o popover que abre ao lado dele */
const ESPACO_POPOVER = 10
/** Largura do popover, espelhando o `width` passado ao ModalPopOver */
const LARGURA_POPOVER = 330
const Configuracoes: React.FC<PropsConfig> = ({ aoCarregarArquivo, validoFile, rotation, setRotation,
    rotacaoInput, setRotacaoInput, movendo, setMovendo, novoPonto, setNovoPonto, moverPonto, setMoverPonto,
    removerPonto, setRemoverPonto, selecionarPonto, setSelecionarPonto, gridLevel, setGridLevel, position,
    setPosition, tab_container_atual, arquivoSelecionado, setArquivoSelecionado,
    setGrid, setGridOriginal, setGridOriginalRotacao, setTamanhoGridOriginal, setQuadrante, kmlComCruzamento,
    editandoKml, areaHectares, polygon, abaAtual, pontosSelecionados, grid, area,
    areaTamanho, quadrante, avancar, voltar, resetarGrid, salvarMalha, baixarMalha, salvarContorno,
    openCorrigirKinks, setOpenCorrigirKinks, correcaoSobreposicoes, temAlgoParaCorrigir,
    aplicarCorrecaoSobreposicoes, openReducaoTrilhas, setOpenReducaoTrilhas, distanciaTrilhas,
    setDistanciaTrilhas, previaReducaoTrilhas, aplicarReducaoTrilhas, openReducaoRetas,
    setOpenReducaoRetas, toleranciaRetas, setToleranciaRetas, previaReducaoRetas,
    aplicarReducaoRetas, alternarEdicaoKml, openPrepararEdicao, setOpenPrepararEdicao,
    preparacaoEdicao, limiteVerticesEdicao, totalVerticesContorno,
    aplicarPreparacaoEdicao, editarSemSimplificar }) => {
    const [show, setShow] = useState<boolean>(false)
    const [shrink, setShrink] = useState<boolean>(false)
    const [loading, setLoading] = useState<string>('')
    const painelRef = useRef<HTMLDivElement | null>(null)
    const [posicaoPopOver, setPosicaoPopOver] = useState<PosicaoPopOver>({ top: 0, left: 0 })
    const algumPopOverAberto =
        openCorrigirKinks || openReducaoTrilhas || openReducaoRetas || openPrepararEdicao
    /**
     * O ModalPopOver é posicionado em coordenadas de tela, mas este painel vive
     * dentro de um Modal centralizado — a posição depende do tamanho da janela.
     * Medimos o painel e abrimos o popover à direita dele; se não couber, cai
     * para a esquerda em vez de vazar pela borda.
     */
    const medirPosicao = useCallback(() => {
        const painel = painelRef.current
        if (!painel) return
        const rect = painel.getBoundingClientRect()
        const aDireita = rect.right + ESPACO_POPOVER
        const cabeADireita = aDireita + LARGURA_POPOVER <= window.innerWidth - ESPACO_POPOVER
        setPosicaoPopOver({
            top: Math.max(ESPACO_POPOVER, Math.round(rect.top)),
            left: Math.round(
                cabeADireita
                    ? aDireita
                    : Math.max(ESPACO_POPOVER, rect.left - LARGURA_POPOVER - ESPACO_POPOVER)
            ),
        })
    }, [])
    // Mede antes da pintura para o popover não aparecer na posição antiga
    useLayoutEffect(() => {
        if (!algumPopOverAberto) return
        medirPosicao()
    }, [algumPopOverAberto, shrink, medirPosicao])
    useEffect(() => {
        if (!algumPopOverAberto) return
        window.addEventListener('resize', medirPosicao)
        return () => window.removeEventListener('resize', medirPosicao)
    }, [algumPopOverAberto, medirPosicao])
    return (
        <PainelPropsGrid ref={painelRef} data-shrink={shrink}>
            <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
                <ButtonCustom
                    onClick={() => {
                        setShrink(!shrink)
                    }}
                    type={shrink ? 'primary' : 'tertiary'}
                    icon={
                        <FontAwesomeIcon
                            icon={shrink ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter}
                        />
                    }
                    style={{ marginLeft: -15, alignSelf: 'flex-end', right: 0 }}
                />
            </div>
            <Render condition={shrink === false}>
                <AbasDoGrid abaAtual={tab_container_atual} mostrar={shrink} />
                {/* Banner de edição KML */}
                <Render condition={show === false}>
                    <Render condition={tab_container_atual === 'Mapa'}>
                        <AbaMapa
                            aoCarregarArquivo={aoCarregarArquivo}
                            validoFile={validoFile}
                            rotation={rotation}
                            setRotation={setRotation}
                            rotacaoInput={rotacaoInput}
                            setRotacaoInput={setRotacaoInput}
                            gridLevel={gridLevel}
                            setGridLevel={setGridLevel}
                            position={position}
                            setPosition={setPosition}
                            movendo={movendo}
                            setMovendo={setMovendo}
                            loading={loading}
                            setLoading={setLoading}
                            setGrid={setGrid}
                            setGridOriginal={setGridOriginal}
                            setGridOriginalRotacao={setGridOriginalRotacao}
                            setTamanhoGridOriginal={setTamanhoGridOriginal}
                            setQuadrante={setQuadrante}
                            areaHectares={areaHectares}
                            polygon={polygon}
                            grid={grid}
                            area={area}
                            editandoKml={editandoKml}
                            kmlComCruzamento={kmlComCruzamento}
                            salvarContorno={salvarContorno}
                            openCorrigirKinks={openCorrigirKinks}
                            setOpenCorrigirKinks={setOpenCorrigirKinks}
                            correcaoSobreposicoes={correcaoSobreposicoes}
                            temAlgoParaCorrigir={temAlgoParaCorrigir}
                            aplicarCorrecaoSobreposicoes={aplicarCorrecaoSobreposicoes}
                            openReducaoTrilhas={openReducaoTrilhas}
                            setOpenReducaoTrilhas={setOpenReducaoTrilhas}
                            distanciaTrilhas={distanciaTrilhas}
                            setDistanciaTrilhas={setDistanciaTrilhas}
                            previaReducaoTrilhas={previaReducaoTrilhas}
                            aplicarReducaoTrilhas={aplicarReducaoTrilhas}
                            openReducaoRetas={openReducaoRetas}
                            setOpenReducaoRetas={setOpenReducaoRetas}
                            toleranciaRetas={toleranciaRetas}
                            setToleranciaRetas={setToleranciaRetas}
                            previaReducaoRetas={previaReducaoRetas}
                            aplicarReducaoRetas={aplicarReducaoRetas}
                            posicaoPopOver={posicaoPopOver}
                            alternarEdicaoKml={alternarEdicaoKml}
                            openPrepararEdicao={openPrepararEdicao}
                            setOpenPrepararEdicao={setOpenPrepararEdicao}
                            preparacaoEdicao={preparacaoEdicao}
                            limiteVerticesEdicao={limiteVerticesEdicao}
                            totalVerticesContorno={totalVerticesContorno}
                            aplicarPreparacaoEdicao={aplicarPreparacaoEdicao}
                            editarSemSimplificar={editarSemSimplificar}
                        />
                    </Render>
                    <Render condition={tab_container_atual === 'Pontos'}>
                        <AbaPontos
                            novoPonto={novoPonto}
                            setNovoPonto={setNovoPonto}
                            moverPonto={moverPonto}
                            setMoverPonto={setMoverPonto}
                            removerPonto={removerPonto}
                            setRemoverPonto={setRemoverPonto}
                            area={areaTamanho}
                            grid={grid}
                            quadrante={quadrante}
                        />
                    </Render>
                    <Render condition={abaAtual === 2}>
                        <AbaOrdenacao
                            selecionarPonto={selecionarPonto}
                            setSelecionarPonto={setSelecionarPonto}
                            arquivoSelecionado={arquivoSelecionado}
                            setArquivoSelecionado={setArquivoSelecionado}
                            pontosSelecionados={pontosSelecionados}
                            resetarGrid={resetarGrid}
                        />
                    </Render>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <ButtonCustom
                            onClick={voltar}
                            type='secondary'
                            danger
                            icon={<FontAwesomeIcon icon={faArrowAltCircleLeft} />}
                            disabled={tab_container_atual === 'Mapa'}
                        >
                            Voltar
                        </ButtonCustom>
                        <Render condition={tab_container_atual === 'Mapa' || tab_container_atual === 'Pontos'}>
                            <ButtonCustom
                                onClick={avancar}
                                type='secondary'
                                icon={<FontAwesomeIcon icon={faArrowAltCircleRight} />}
                                disabled={grid.length <= 0 || kmlComCruzamento}
                            >
                                Avançar
                            </ButtonCustom>
                        </Render>
                        <Render condition={abaAtual === 2}>
                            <Popover
                                trigger='click'
                                placement='topRight'
                                content={
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 90 }}>
                                        <ButtonCustom
                                            onClick={() => baixarMalha(arquivoSelecionado)}
                                            type='secondary'
                                            disabled={!arquivoSelecionado}
                                            icon={<FontAwesomeIcon icon={faFileExport} />}
                                            style={{ width: '100%' }}
                                        >
                                            Baixar
                                        </ButtonCustom>
                                        <ButtonCustom
                                            onClick={() => salvarMalha()}
                                            type='primary'
                                            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                                            style={{ width: '100%' }}
                                        >
                                            Salvar
                                        </ButtonCustom>
                                    </div>
                                }
                            >
                                <span>
                                    <ButtonCustom
                                        type='secondary'
                                        onClick={() => { }}
                                        icon={<FontAwesomeIcon icon={faList} />}
                                    >
                                        Opções
                                    </ButtonCustom>
                                </span>
                            </Popover>
                        </Render>
                    </div>
                </Render>
            </Render>
            <Render condition={show}>
                <Carregando animation legenda='Carregando...' justifyContent='center' height={400} />
            </Render>
        </PainelPropsGrid>
    )
}
export default React.memo(Configuracoes)